import type { TableColumn } from "../../../../../../components/table";

export const tableColumns: TableColumn<any>[] = [
  {
    title: "STT",
    size: "medium",
    renderCell: (row, index) => index,
  },
  {
    title: "Nội dung",
    size: "medium",
    renderCell: (row) => row.Content,
  },
  {
    title: "Đơn vị tính",
    renderCell: (row) => row.Unit,
  },
  {
    title: "Số lượng đề nghị",
    renderCell: (row) => row.SuggestedQuantity,
  },
  {
    title: "Thời gian dự kiến sử dụng",
    renderCell: (row) => row.EstimatedTimeOfUse,
  },
  {
    title: "Ghi chú/Giải trình",
    renderCell: (row) => row.Notes,
  },
];
